const initialState = () => ({
  notices: [],
  total: null,
  read: null,
  unread: null,
  status: null,
  scheduleds: null,
  homeFetched: false
})

export default initialState
